import { render, staticRenderFns } from "./cpt-chart-map-migrate.vue?vue&type=template&id=2d894339&scoped=true"
import script from "./cpt-chart-map-migrate.vue?vue&type=script&lang=js"
export * from "./cpt-chart-map-migrate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d894339",
  null
  
)

export default component.exports